export default __webpack_public_path__ + "d91d4268a843097b209539a4ae582aac.png";